export type ConsentStatus = 'yes' | 'no' | 'undecided'

const COOKIE_NAME = 'cookie_consent'
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60 // 1 year

function getCookieDomainPart(): string {
  const hostname = location.hostname
  if (hostname === 'localhost' || hostname === '127.0.0.1') return ''
  return `; domain=.${hostname.split('.').slice(-2).join('.')}`
}

export function setCookieConsent(status: 'yes' | 'no'): void {
  const domainPart = getCookieDomainPart()
  const securePart = location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${COOKIE_NAME}=${status}${domainPart}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax${securePart}`
}

export function cookieConsentGiven(): ConsentStatus {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`))
  if (match) return match[1] as ConsentStatus

  // Migrate from localStorage if present (one-time)
  try {
    const lsConsent = localStorage.getItem(COOKIE_NAME)
    if (lsConsent === 'yes' || lsConsent === 'no') {
      setCookieConsent(lsConsent)
      localStorage.removeItem(COOKIE_NAME)
      return lsConsent
    }
  } catch {
    // localStorage may be unavailable
  }

  return 'undecided'
}
